import request from '../utils/user_request'
export function createDepartment (data) {
  return request({
    url: '/department/create',
    method: 'POST',
    data
  })
}
export function queryChildrenRegion (parentRegionId) {
  return request({
    url: '/region/children',
    method: 'GET',
    params: {
      parentRegionId: parentRegionId
    }
  })
}
export function queryRegion (regionId) {
  return request({
    url: '/region/get',
    method: 'GET',
    params: {
      regionId: regionId
    }
  })
}
export function queryDepartment (parentDepartmentId) {
  return request({
    url: '/department/children',
    method: 'GET',
    params: {
      parentDepartmentId: parentDepartmentId
    }
  })
}
export function deleteDepartment (departmentId) {
  return request({
    url: '/department/delete',
    method: 'GET',
    params: {
      departmentId: departmentId
    }
  })
}
export function getDepartmentDetails (departmentId) {
  return request({
    url: '/department/get',
    method: 'GET',
    params: {
      departmentId: departmentId
    }
  })
}
export function updateDepartment (updateDepartmentForm) {
  return request({
    url: '/department/update',
    method: 'POST',
    data: updateDepartmentForm
  })
}
export function queryPositionLists (queryPositionParams) {
  return request({
    url: '/position/search',
    method: 'POST',
    data: queryPositionParams
  })
}
export function addPosition (addPositionParams) {
  return request({
    url: '/position/create',
    method: 'POST',
    data: addPositionParams
  })
}
export function updatePosition (updatePositionParams) {
  return request({
    url: '/position/update',
    method: 'POST',
    data: updatePositionParams
  })
}
export function deletePosition (positionId) {
  return request({
    url: '/position/delete',
    method: 'GET',
    params: {
      positionId: positionId
    }
  })
}
export function getAccessMenu (authKey) {
  return request({
    url: '/resource/accessMenu',
    method: 'GET',
    params: {
      authKey: authKey
    }
  })
}
export function queryAllDepartment () {
  return request({
    url: '/department/getAll',
    method: 'GET'
  })
}
export function queryAuthCity (parentRegionId) {
  return request({
    url: '/region/accessChildren',
    method: 'GET',
    params: {
      parentRegionId: parentRegionId
    }
  })
}
export function getTenantAdmin (tenantId) {
  return request({
    url: '/tenant/getTenantAdmin',
    method: 'GET',
    params: {
      tenantId: tenantId
    }
  })
}
export function changeTenantAdminPassword (params) {
  return request({
    url: '/tenant/changeTenantAdminPassword',
    method: 'POST',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/userRequest.js